import { useState, useEffect } from 'react';
import { VisualizeEngine } from '@tier4/autowareviz-core';
import { MediaEngine, DataEngine } from '@tier4/autowareviz-react';
import { MessageEngine } from '@tier4/autowareviz-messages';
import { ObjectEngine } from '@tier4/autowareviz-threejs';

export function useVisualizeEngine() {
    const [engine, setEngine] = useState<VisualizeEngine>();
    useEffect(() => {
        const engine = new VisualizeEngine({
            messageEngine: new MessageEngine(),
            mediaEngine: new MediaEngine(),
            dataEngine: new DataEngine(),
            objectEngine: new ObjectEngine(),
        });
        setEngine(engine);
        return () => {
            engine.dispose();
        };
    }, []);

    return engine;
}
